<template>
  <div class="user-add-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <div class="title">TBOX管理</div>
      <div class="box">
        <div class="form">
          <el-form
            ref="form"
            :class="{ formedit: editflge }"
            :rules="rules"
            :model="form"
            label-width="160px"
          >
            <el-row
              :gutter="5"
              style="text-align: left; margin-bottom: 10px; margin-left: 58px"
            >
              <el-button
                type="primary"
                v-if="editflge && edit"
                @click="editflge = !editflge"
                class="rigth"
                v-hasPermi="['TBOX管理', '编辑']"
                >编辑</el-button
              >
              <el-button
                type="primary"
                v-if="!editflge && id"
                @click="editflge = !editflge"
                class="rigth"
                >取消编辑</el-button
              >
              <el-button
                type="primary"
                v-if="!editflge && id"
                @click="submitForm('form')"
                >保存信息</el-button
              >
            </el-row>
            <!--***********生产用户****start********************-->
            <template
              v-if="
                $store.state.home.RoleId == this.user_role_proc ||
                $store.state.home.RoleId == this.user_role_admin ||
                $store.state.home.RoleId > 7
              "
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="TBOX编号" prop="sn">
                    <el-input
                      v-model="form.sn"
                      :disabled="editflge"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车辆品牌">
                    <el-input
                      v-model="noform.brand"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车架号">
                    <el-input
                      v-model="form.vin"
                      :disabled="editflge"
                      @focus.stop="dialogVisible = true"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车型">
                    <el-input
                      v-model="noform.model"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆型号">
                    <el-input
                      v-model="noform.type"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="ic卡" prop="iccid">
                    <el-input
                      v-model="form.iccid"
                      :disabled="editflge"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="软件版本编号" prop="tboxversionold">
                    <el-input
                      v-model="form.tboxversionold"
                      :disabled="editflge"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="预设秘钥" prop="peraeskey">
                    <el-input
                      v-model="form.peraeskey"
                      :disabled="editflge"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="ROLLNUMBER">
                    <el-input
                      v-model="form.rollNumber"
                      :disabled="true"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="BID码">
                    <el-input
                      v-model="form.bid"
                      :disabled="true"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="T-BOX有效期" prop="validtime">
                    <el-date-picker
                      style="width: 100%"
                      v-model="form.validtime"
                      type="date"
                      :disabled="editflge"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="厂家" prop="factory_id">
                    <el-select
                      v-model="form.factory_id"
                      :disabled="editflge"
                      placeholder="请选择"
                      style="width: 100%; display: inline-block"
                    >
                      <el-option
                        v-for="item in options.factory"
                        :key="item.id"
                        :label="item.factory_name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="生产时间">
                    <el-date-picker
                      style="width: 100%"
                      v-model="form.procTime"
                      type="date"
                      :disabled="editflge"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="公司名称">
                    <el-select
                      v-model="form.belongCompany"
                      style="width: 100%"
                      placeholder="请选择"
                      :disabled="editflge"
                      clearable
                    >
                      <el-option
                        v-for="item in companyList"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <!--***********生产用户****end********************-->
            <!--***********4s店 或 自定义****start********************-->
            <template
              v-else-if="
                $store.state.home.RoleId == this.user_role_four ||
                $store.state.home.RoleId == this.user_role_defind
              "
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="TBOX编号" prop="sn">
                    <el-input
                      v-model="form.sn"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车辆品牌">
                    <el-input
                      v-model="noform.brand"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车架号">
                    <el-input
                      v-model="form.vin"
                      :disabled="editflge"
                      @focus.stop="dialogVisible = true"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车型">
                    <el-input
                      v-model="noform.model"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆型号">
                    <el-input
                      v-model="noform.type"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="软件版本编号" prop="tboxversionold">
                    <el-input
                      v-model="form.tboxversionold"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="T-BOX有效期" prop="validtime">
                    <el-date-picker
                      style="width: 100%"
                      v-model="form.validtime"
                      type="date"
                      disabled
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="厂家" prop="factory_id">
                    <el-select
                      v-model="form.factory_id"
                      :disabled="editflge"
                      placeholder="请选择"
                      style="width: 100%; display: inline-block"
                    >
                      <el-option
                        v-for="item in options.factory"
                        :key="item.id"
                        :label="item.factory_name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="生产时间">
                    <el-date-picker
                      style="width: 100%"
                      v-model="form.procTime"
                      type="date"
                      disabled
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="公司名称">
                    <el-select
                      v-model="form.belongCompany"
                      style="width: 100%"
                      placeholder="请选择"
                      :disabled="editflge"
                      clearable
                    >
                      <el-option
                        v-for="item in companyList"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <!--***********4s店****end********************-->
            <!--***********租赁公司****start********************-->
            <template
              v-else-if="$store.state.home.RoleId == this.user_role_rent"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆品牌">
                    <el-input
                      v-model="noform.brand"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="BID码">
                    <el-input
                      v-model="form.bid"
                      :disabled="true"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车架号">
                    <el-input
                      v-model="form.vin"
                      :disabled="editflge"
                      @focus.stop="dialogVisible = true"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车型">
                    <el-input
                      v-model="noform.model"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="车辆型号">
                    <el-input
                      v-model="noform.type"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="软件版本编号" prop="tboxversionold">
                    <el-input
                      v-model="form.tboxversionold"
                      disabled
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="T-BOX有效期" prop="validtime">
                    <el-date-picker
                      style="width: 100%"
                      v-model="form.validtime"
                      type="date"
                      disabled
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="厂家" prop="factory_id">
                    <el-select
                      v-model="form.factory_id"
                      :disabled="editflge"
                      placeholder="请选择"
                      style="width: 100%; display: inline-block"
                    >
                      <el-option
                        v-for="item in options.factory"
                        :key="item.id"
                        :label="item.factory_name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="生产时间">
                    <el-date-picker
                      style="width: 100%"
                      v-model="form.procTime"
                      type="date"
                      disabled
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="公司名称">
                    <el-select
                      v-model="form.belongCompany"
                      style="width: 100%"
                      placeholder="请选择"
                      :disabled="editflge"
                      clearable
                    >
                      <el-option
                        v-for="item in companyList"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <!--***********租赁公司****end********************-->
          </el-form>
          <div class="btns" v-if="edit">
            <el-button type="primary" v-if="!id" @click="submitForm('form')"
              >保存信息</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <popup v-if="dialogVisible" @parent="childHanel" />
  </div>
</template>

<script>
import { addTbox, updateTbox, dataSelectFactory, dataSelectTbox, getCarCompanyList } from '@/api/tbox'
import popup from './popup'
export default {
  components: { popup },
  data () {
    return {
      editflge: true,
      edit: (this.$store.state.home.RoleId == this.user_role_admin || this.$store.state.home.RoleId == this.user_role_proc || this.$store.state.home.RoleId > 7),
      id: null,
      dialogVisible: false,
      rules: {
        sn: [
          { required: true, message: '请输入TBOX编号', trigger: 'blur' },
          { min: 29, max: 29, message: 'TBOX编号固定为29位！', trigger: 'blur' }
        ],
        iccid: [
          { required: true, message: '请输入ic卡', trigger: 'blur' }
        ],
        peraeskey: [
          { required: true, message: '请输入预设秘钥', trigger: 'blur' }
        ],
        tboxversionold: [
          { required: true, message: '请输入软件版本编号', trigger: 'blur' }
        ],
        validtime: [
          { required: true, message: '请选择T-BOX有效期', trigger: 'change' }
        ],
        factory_id: [
          { required: true, message: '请选择厂家', trigger: 'change' }
        ],
        vin: [
          { required: false, message: '请选择车架号', trigger: 'change' }
        ]
      },
      noform: {},
      form: {
        vin: '',
      },
      options: {
        factory: []
      },
      companyList: []
    }
  },
  created () {
    this.id = this.$route.query.id
    if (this.id) {
      this.getData()
    } else {
      this.editflge = false
    }
    this.getfactoryData()
    getCarCompanyList().then(da => {
      this.companyList = da.data
    })
  },
  methods: {
    getfactoryData () {
      dataSelectFactory().then(res => {
        this.options.factory = res.data.content
      })
    },
    childHanel (val) {
      this.form.vin = val.frame_num
      this.noform = val
      this.$refs.form.clearValidate('vin')
    },
    getData () {
      const params = { id: this.$route.query.id }
      dataSelectTbox(params)
        .then(res => {
          this.form = res.data.content[0]
          this.form.belongCompany = parseInt(this.form.belongCompany) || ''
          this.noform.brand = res.data.content[0].brand
          this.noform.type = res.data.content[0].type
          this.noform.model = res.data.content[0].model
        })
    },
    updateTbox () {
      delete this.form.brand
      delete this.form.type
      delete this.form.model
      updateTbox(this.form).then(res => {
        this.$message.success('保存成功!')
        this.$router.back(-1)
      })
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$route.query.id) {
            this.updateTbox()
            return
          }
          addTbox(this.form).then(res => {
            this.$message.success('保存成功!')
            this.$router.back(-1)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.user-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    .box {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        max-width: 1100px;
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
.formedit {
  input::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #fff !important;
  }
  i {
    display: none;
  }
  .el-input.is-disabled .el-input__inner {
    cursor: auto;
    background-color: #fff;
    border: 0;
  }
}
</style>